export default __webpack_public_path__ + "static/media/README.2a0774a1.md";